//import Airtable from 'airtable'

async function fetchData(url, args) {
  let fullUrl = `https://api.airtable.com/v0/${url}`
  let key =
    'patH2B3haNcbo2sdR.9149c5672c4549b97b81a0f17ad25c26fd402308fbcbd1502b52b2f2f05e5dde'

  try {
    if (!Object.keys(args).includes('headers')) {
      args.headers = {}
    }

    args.headers['Authorization'] = `Bearer ${key}`

    const response = await fetch(fullUrl, args)
    if (!response.ok) {
      return false
    }
    return await response.json()
  } catch (error) {
    console.error(`Error fetching data from ${fullUrl}:`, error)
    throw error
  }
}

export async function retrieveProduct(productModelID) {
  console.log('📞 hellooooo airtable (SKU)')

  let formula = encodeURIComponent(`{Commercial Item}="${productModelID}"`)

  return fetchData(
    `appR3RtLeneIoWv9Y/SKU's?filterByFormula=${formula}&view=SSR&maxRecords=1`,
    {
      method: 'GET',
    },
  )
}

export async function retrieveProducts() {
  console.log('📞 hellooooo airtable (SSR)')

  return fetchData(
    `appR3RtLeneIoWv9Y/SKU's?filterByFormula=%7BPhase%7D%3D%22Phase%202%22&view=SSR`,
    {
      method: 'GET',
    },
  )
}

export const fetchProductData = async (modelId) => {
  // Current model is a set
  const modelIsSet = modelId.indexOf('SET') !== -1

  // Retrieve the main product data
  const productDataResponse = await retrieveProduct(modelId)

  // TODO wil CZ dan hierna dat wij in de viewer de sets data opvangen? Bekijk suggestie op slack

  // Initialize xsells as an empty array if there aren't any
  let xsells = []

  if (productDataResponse?.crossSelling?.length) {
    productDataResponse.crossSelling.forEach((xsell) => {
      xsells.push(xsell.baseModel)
    })
  }

  // sets flattenen
  if (productDataResponse?.items?.length && modelIsSet) {
    productDataResponse.items.forEach((item) => {
      // basemodel, zonder crossSelling
      if (
        item?.baseModel?.code &&
        item?.baseModel?.variants &&
        xsells.findIndex((product) => product.code === item.baseModel.code) ===
          -1
      ) {
        xsells.push({
          code: item.baseModel.code,
          variants: item.baseModel.variants,
        })
      }
      // xsells van elk model
      if (item?.baseModel?.crossSelling?.length) {
        item.baseModel.crossSelling.forEach((item_xsell) => {
          if (
            xsells.findIndex(
              (product) => product.code === item_xsell.baseModel.code,
            ) === -1
          ) {
            xsells.push({
              code: item_xsell.baseModel.code,
              variants: item_xsell.baseModel.variants,
            })
          }
        })
      }
    })
  }

  // xsells filtering voor sets
  if (xsells.length && modelIsSet) {
    let extra_xsells = []
    let extra_xsells_filtered = []

    // toevoegingen voor alle MBOLSET's
    if (modelId.indexOf('MBOLSET') !== -1) {
      extra_xsells.push('PIL45M')
    }

    // toevoegingen voor alle MZXSET's
    if (modelId.indexOf('MZXSET') !== -1) {
      extra_xsells.push('PIL45M')
      extra_xsells.push('PIL64M')
    }

    // toevoegingen voor alle NNXLSET's
    if (modelId.indexOf('NNXLSET') !== -1) {
      extra_xsells.push('PIL45M')
    }

    // toevoegingen voor NNXLSET03
    if (modelId.indexOf('NNXLSET03') !== -1) {
      extra_xsells.push('NNX150TW')
    }

    // toevoegingen voor alle STYLSET's
    if (modelId.indexOf('STYLSET') !== -1) {
      extra_xsells.push('PIL45M')
      extra_xsells.push('PIL64M')
    }

    /*

    CLYLSET01
    PIL40M, PIL45M, PIL64M

    CLYLSET02
    PIL40M, PIL45M, PIL53M

    CLYLSET03
    PIL40M, PIL45M, PIL53M

    CLYLSET04
    PIL40M, PIL45M

    CLYLSET05
    PIL40M, PIL45M, PIL53M

    CLYLSET06
    PIL40M, PIL45M, PIL53M, PIL64M

     */

    // toevoegingen voor alle CLYLSET's
    if (modelId.indexOf('CLYLSET') !== -1) {
      extra_xsells.push('PIL40M')
      extra_xsells.push('PIL45M')
    }

    // toevoegingen voor de CLYLSET01
    if (modelId.indexOf('CLYLSET01') !== -1) {
      extra_xsells.push('PIL64M')
    }

    // toevoegingen voor alle MZXALSET's
    if (modelId.indexOf('MZXALSET') !== -1) {
      extra_xsells.push('PIL45M')
      extra_xsells.push('PIL64M')
    }

    // toevoegingen voor de MZXALSET04
    if (modelId.indexOf('MZXALSET04') !== -1) {
      extra_xsells.push('MZXTILE')
    }

    // check extras
    extra_xsells.forEach((xsell) => {
      if (findProductIndexByIdentifier(xsells, xsell) === -1) {
        extra_xsells_filtered.push(xsell)
      }
    })

    // extra data ophalen
    const extra_xsellsPromises = extra_xsells_filtered.map((sub_xcell_id) =>
      retrieveProduct(sub_xcell_id),
    )

    let extra_xsells_data = await Promise.all(extra_xsellsPromises)

    if (extra_xsells_data.length) {
      extra_xsells_data.forEach((extra_xsell) => {
        xsells.push({
          code: extra_xsell.code,
          variants: extra_xsell.variants,
        })
      })
    }

    // strips voor mbolset1
    if (modelId.indexOf('MBOLSET01') !== -1) {
      spliceProductsFromObjectArray(
        ['PILMBOL270', 'PILMBOL90S', 'PILMBOL270CL', 'PILMBOL270CR'],
        xsells,
      )
    }

    // strips voor mbolset2
    if (modelId.indexOf('MBOLSET02') !== -1) {
      spliceProductsFromObjectArray(
        [
          'PILMBOL180',
          'PILMBOL90S',
          'PILMBOL90B',
          'PILMBOL270CL',
          'PILMBOL270CR',
        ],
        xsells,
      )
    }

    // strippen enkel indien NIET set 03
    if (modelId.indexOf('MBOLSET03') === -1) {
      spliceProductsFromObjectArray(['PILMBOL270CR'], xsells)
    }

    // strippen indien set03
    if (modelId.indexOf('MBOLSET03') !== -1) {
      spliceProductsFromObjectArray(
        ['PILMBOL270', 'PILMBOL180', 'PILMBOL270CL', 'PILMBOL270CR'],
        xsells,
      )
    }

    // strips voor mbolset4
    if (modelId.indexOf('MBOLSET04') !== -1) {
      spliceProductsFromObjectArray(
        ['MBOL270', 'PILMBOL90S', 'PILMBOL90B', 'PILMBOL90CSL', 'PILMBOL270CL'],
        xsells,
      )
    }

    // strips voor mbolset6
    if (modelId.indexOf('MBOLSET06') !== -1) {
      spliceProductsFromObjectArray(['PILMBOL90S', 'PILMBOL90B'], xsells)
    }

    // strips voor mbolset6
    if (modelId.indexOf('MBOLSET08') !== -1) {
      spliceProductsFromObjectArray(
        [
          'PILMBOL90S',
          'PILMBOL90B',
          'PILMBOL90CB',
          'PILMBOL90CSR',
          'PILMBOL180',
        ],
        xsells,
      )
    }

    // strips voor ogxlset01
    if (modelId.indexOf('OGXLSET01') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL450'], xsells)
    }

    // strips voor ogxlset02
    if (modelId.indexOf('OGXLSET02') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL450'], xsells)
    }

    // strips voor ogxlset03
    if (modelId.indexOf('OGXLSET03') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL01A'], xsells)
    }

    // strips voor ogxlset04
    if (modelId.indexOf('OGXLSET04') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL02A', 'PILOGXL04A'], xsells)
      // TODO PILOGXL04B en OGXL08TOPCPC zitteb niet in de nieuwe API, in Akeneo wél, dus zal Dato sync zijn die moet lopen, Steven is gebriefd.
    }

    // strips voor ogxlset05
    if (modelId.indexOf('OGXLSET05') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL02A', 'PILOGXL01A'], xsells)
    }

    // strips voor ogxlset07
    if (modelId.indexOf('OGXLSET07') !== -1) {
      spliceProductsFromObjectArray(['PILOGXL01A'], xsells)
    }

    // xsell renaming voor OGXLSET
    if (modelId.indexOf('OGXLSET') !== -1) {
      const ogxlset_regex = /^OGXL[01]\d{1}$/
      xsells.forEach((xsell, index) => {
        if (ogxlset_regex.test(xsells[index].code)) {
          xsells[index].code += 'A'
        }

        // T's replacen
        if (
          modelId.indexOf('OGXLSET03') !== -1 ||
          modelId.indexOf('OGXLSET04') !== -1 ||
          modelId.indexOf('OGXLSET05') !== -1 ||
          modelId.indexOf('OGXLSET07') !== -1
        ) {
          if (xsells[index].code === 'OGXL08T') {
            xsells[index].code = 'OGXL08A'
          }
          if (xsells[index].code === 'OGXL07T') {
            xsells[index].code = 'OGXL07A'
          }
          if (xsells[index].code === 'OGXL06T') {
            xsells[index].code = 'OGXL06A'
          }
        }

        // pillows renamen binnen 7
        if (modelId.indexOf('OGXLSET07') !== -1) {
          if (xsells[index].code === 'PILOGXL01A') {
            xsells[index].code = 'PILOGXL01B'
          }
        }
      })
    }

    // strippen indien stylset01
    if (modelId.indexOf('STYLSET01') !== -1) {
      spliceProductsFromObjectArray(
        ['PILBRH7240PS', 'STYLCONNECTSET', 'PILBRH6540PS'],
        xsells,
      )
    }

    // strippen indien stylset03
    if (modelId.indexOf('STYLSET03') !== -1) {
      spliceProductsFromObjectArray(
        [
          'STYL210B',
          'STYL210',
          'PILSTYL2109S',
          'PILSTYL210S',
          'PILCLYL140S',
          'PILCLYL70S',
        ],
        xsells,
      )
    }

    // strippen indien stylset04
    if (modelId.indexOf('STYLSET04') !== -1) {
      spliceProductsFromObjectArray(['PILSTYL2109S'], xsells)
    }

    // strippen indien stylset05 + 07
    if (
      modelId.indexOf('STYLSET05') !== -1 ||
      modelId.indexOf('STYLSET07') !== -1
    ) {
      spliceProductsFromObjectArray(['PILCLYL140S', 'PILCLYL70S'], xsells)
    }

    // strippen indien stylset07
    if (modelId.indexOf('STYLSET07') !== -1) {
      spliceProductsFromObjectArray(
        ['STYL210', 'PILSTYL2109S', 'STYL70'],
        xsells,
      )
    }

    // strippen indien MZXSET06
    if (modelId.indexOf('MZXSET06') !== -1) {
      spliceProductsFromObjectArray(['MZXPL12', 'PIL64M'], xsells)
    }
  }

  // xsell renamen als het om de alura gaat en pillows heeft
  const alura_regex = /ALRL[01]\d[A-Z]/g
  if (alura_regex.test(modelId) && xsells.length) {
    // wat is de laatste letter van het id?
    let modelid_last_letter = modelId.substring(modelId.length - 1)
    xsells.forEach((xsell, index) => {
      if (xsell.code.indexOf('PIL') !== -1) {
        let xsellid_last_two_letters = xsell.code.substring(
          xsell.code.length - 2,
        )
        let xsellid_last_four_letters = xsell.code.substring(
          xsell.code.length - 4,
        )
        if (
          xsellid_last_two_letters === 'AB' ||
          xsellid_last_four_letters === '16CD'
        ) {
          // indien xsell eindigt op 'AB', kijk naar de laatste letter en vervang AB met die laatste letter
          xsells[index].code =
            xsells[index].code.substring(0, xsells[index].code.length - 2) +
            modelid_last_letter
        } else if (xsellid_last_two_letters !== 'CD') {
          // voeg laatste letter van model toe aan xsell id (als de twee laatste letters van de xsell niet CD zijn
          xsells[index].code = xsells[index].code + modelid_last_letter
        }
      } else if (xsell.code === 'ALRL80TOPC') {
        xsell.code = modelId + '_' + xsell.identifier
      }
    })
  }

  // Construct the main product model
  let constructedProductModel = constructProductData(productDataResponse)

  // Add cross-sell data to the constructed product model
  constructedProductModel.crossSellData = xsells.map((xsell) =>
    constructProductData(xsell),
  )

  return [constructedProductModel]
}

function findProductIndexByIdentifier(products, product_id_to_find) {
  return products.findIndex((product) => product.code === product_id_to_find)
}

function spliceProductsFromArray(products, array) {
  products.forEach((id) => {
    let searched_index = array.indexOf(id)

    if (searched_index !== -1) {
      array.splice(searched_index, 1)
    }
  })
}

function spliceProductsFromObjectArray(products, array) {
  products.forEach((product) => {
    let searched_index = findProductIndexByIdentifier(array, product)

    if (searched_index !== -1) {
      array.splice(searched_index, 1)
    }
  })
}

export function constructProductData(productData) {
  let productMaterials = deconstructMaterialIds(productData.variants)

  // Combine axesMaterials and staticMaterials into a single array
  let materialData = [
    ...productMaterials.axesMaterials,
    ...productMaterials.staticMaterials,
  ]

  materialData = removeDuplicateArrays(materialData)

  return {
    modelCode: productData.code,
    materialData: materialData,
  }
}

function deconstructMaterialIds(variants) {
  let materialsByType = {
    axesMaterials: {},
    staticMaterials: {},
  }

  if (typeof variants === 'undefined') {
    variants = []
  }

  variants.forEach((variant) => {
    // Process axes_map materials
    Object.values(variant.metadata.axesMap).forEach((material) => {
      if (material.axesMapType === 'batyline_colour') {
        material.axesMapType = 'colour_batyline'
      }
      if (material.axesMapType === 'pole_material_colour') {
        material.axesMapType = 'frame_material_colour'
      }
      if (!materialsByType.axesMaterials[material.axesMapType]) {
        materialsByType.axesMaterials[material.axesMapType] = []
      }
      if (
        !materialsByType.axesMaterials[material.axesMapType].some(
          (existingMaterial) =>
            existingMaterial.id === material.material.materialId,
        )
      ) {
        materialsByType.axesMaterials[material.axesMapType].push({
          id: material.material.materialId,
          code: material.axesMapCode,
          label: material.axesMapLabel,
          type: material.axesMapType,
          material: material.material,
        })
      }
    })

    // Process staticMaterials
    if (variant.metadata.staticMaterials) {
      variant.metadata.staticMaterials.forEach((material) => {
        if (!materialsByType.staticMaterials[material.reference]) {
          materialsByType.staticMaterials[material.reference] = []
        }
        if (
          !materialsByType.staticMaterials[material.reference].some(
            (existingMaterial) => existingMaterial.id === material.materialId,
          )
        ) {
          materialsByType.staticMaterials[material.reference].push({
            id: material.materialId,
            code: material.code,
            type: material.reference,
            material: material,
          })
        }
      })
    }
  })

  return {
    axesMaterials: Object.values(materialsByType.axesMaterials).flat(),
    staticMaterials: Object.values(materialsByType.staticMaterials).flat(),
  }
}

function removeDuplicateArrays(materialData) {
  const uniqueMaterials = []
  const materialKeys = new Set()

  materialData.forEach((material) => {
    const key = `${material.code}-${material.type}`
    if (!materialKeys.has(key)) {
      materialKeys.add(key)
      uniqueMaterials.push(material)
    }
  })

  return uniqueMaterials
}
